import request from '@/utils/request'


// 查询订单售后列表
export function listAfter(query) {
  return request({
    url: '/order/order-after/list',
    method: 'get',
    params: query
  })
}

// 查询订单售后分页
export function pageAfter(query) {
  return request({
    url: '/order/order-after/page',
    method: 'get',
    params: query
  })
}

// 查询订单售后详细
export function getAfter(data) {
  return request({
    url: '/order/order-after/detail',
    method: 'get',
    params: data
  })
}

// 新增订单售后
export function addAfter(data) {
  return request({
    url: '/order/order-after/add',
    method: 'post',
    data: data
  })
}

// 修改订单售后
export function updateAfter(data) {
  return request({
    url: '/order/order-after/edit',
    method: 'post',
    data: data
  })
}

// 删除订单售后
export function delAfter(data) {
  return request({
    url: '/order/order-after/delete',
    method: 'post',
    data: data
  })
}
